<section class="platform-businesses-connection">
  <div class="wrapper">
    <div class="topic-businesses-connection">
      <h4 class="title">
        <span
          >{{ 'PLATFORM_BUSINESSES.TOPIC_CONNECTION.1' | translate
          }}{{ 'PLATFORM_BUSINESSES.TOPIC_CONNECTION.2' | translate }}</span
        ></h4
      >
    </div>

    <!-- START: CONNECTION TAB -->
    <div class="payment-tab-container">
      <div class="box-wrapper">
        <ng-container *ngFor="let item of PaymentList">
          <button
            class="box-wrapper__navigation selected"
            (click)="onClickSelectedTab(item.data.tagName.iv)"
            [ngClass]="{ selected: selectedTabType === item.data.tagName.iv }"
          >
            <div class="box-wrapper__navigation-text">
              <span>{{ 'PLATFORM_BUSINESSES.CONNECTION_TAB_TYPE.' + item.data.tagName.iv | translate }}</span>
            </div>
          </button>
        </ng-container>
      </div>
    </div>
    <!-- END: CONNECTION TAB -->

    <!-- START: PARTNER SECTION -->
    <div class="platform-businesses-partner-wrapper">
      <div class="box">
        <div class="swiper-container-main">
          <swiper-container class="swiper" appSwiper #swiperComponent [config]="config" init="false">
            <ng-container class="swiper-slide-container" *ngFor="let item of filteredConnections">
              <swiper-slide class="swiper-slide">
                <a class="connection" [routerLink]="[item.data.nameUrl.iv]" target="_blank" rel="noopener noreferrer">
                  <div class="connection-card">
                    <div class="connection-card__image">
                      <img
                        [ngClass]="item.data.nameUrl?.iv"
                        src="{{
                          item.data.logo?.iv
                            ? item.data.logo?.iv
                            : 'https://flowaccountcdn.com/new_landing/image/accountingfirm/find-accountingfirm/back-logo.png'
                        }}"
                        [alt]="item.data.nameUrl?.iv"
                        loading="lazy"
                        draggable="false"
                      />
                    </div>
                    <div class="connection-card__desc">
                      <span>
                        {{ translate.currentLang === 'th' ? item.data.desc.th : item.data.desc.en }}
                      </span>
                    </div>

                    <div class="connection-card__href">
                      <div class="connection-card__href-nameUrl-right">
                        <a
                          [routerLink]="item.data.nameUrl.iv"
                          target="_blank"
                          class="routerLink-color"
                          rel="noopener noreferrer"
                        >
                          <span>{{
                            translate.currentLang === 'th'
                              ? item.data.HyperlinkTextToSubPage.th
                              : item.data.HyperlinkTextToSubPage.en
                          }}</span>
                        </a>
                        <i class="fas fa-angle-right"></i>
                      </div>
                    </div>
                  </div>
                </a>
              </swiper-slide>
            </ng-container>
          </swiper-container>
          <div class="swiper-button-prev">
            <i class="fas fa-arrow-left"></i>
          </div>
          <div class="swiper-button-next">
            <i class="fas fa-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
